// extracted by mini-css-extract-plugin
export default {"Container":"TeamMember_Container__dMLkG","MemberContainer":"TeamMember_MemberContainer__9lUrx","SubTitle":"TeamMember_SubTitle__VRMND","Title":"TeamMember_Title__TnHsl"};